import HeroSection from "../components/home/HeroSection";
import OfferStrip from "../components/home/OfferStrip";
import TopSellers from "../components/home/TopSellers";
import CategoryGrid from "../components/home/CategoryGrid";
import FeaturedProducts from "../components/home/FeaturedProducts";
import SafetyStandards from "../components/home/SafetyStandards";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <OfferStrip />
      <TopSellers />
      <CategoryGrid />
      <FeaturedProducts />
      <SafetyStandards />
    </div>
  );
};

export default Home;
